import InfoPage from "@/pages/InfoPage";

export default function CookiePolicy() {
  return (
    <InfoPage
      testId="cookie-policy-page"
      eyebrow="Important Information"
      title="Cookie Policy"
      intro="This page explains how AGS Cleaning Services uses cookies and similar technologies on ags-services.ie. By continuing to use our website, you consent to our use of essential cookies; non-essential cookies are only set when you opt in."
      sections={[
        {
          heading: "1. What are cookies?",
          body: "Cookies are small text files stored on your device by your browser when you visit a website. They allow the website to remember your actions and preferences (e.g. language, region, login state).",
        },
        {
          heading: "2. Cookies we use",
          body: "We use a small number of strictly necessary and analytics cookies:",
          list: [
            "Strictly necessary — required to load the site, remember form state, and submit your quote / application requests",
            "Analytics (optional) — anonymised page-view data so we can improve content and navigation",
            "We do not use advertising or cross-site tracking cookies",
          ],
        },
        {
          heading: "3. Managing cookies",
          body: "You can accept or refuse non-essential cookies via the consent banner displayed on your first visit. You can also delete cookies and adjust permissions in your browser settings at any time.",
        },
        {
          heading: "4. Third-party cookies",
          body: "Where embedded content (e.g. a Google Map showing our office location) is loaded from a third party, that provider may set its own cookies. We display embedded content only with your consent.",
        },
        {
          heading: "5. Changes to this policy",
          body: "If we add new tools that use cookies, we will update this page and re-request consent where required. Significant changes will be highlighted on the homepage.",
        },
        {
          heading: "6. Contact",
          body: "Cookie questions? Email info@ags-services.ie.",
        },
      ]}
    />
  );
}
